import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-payer',
  templateUrl: './payer.component.html',
  styleUrls: ['./payer.component.scss']
})
export class PayerComponent implements OnInit {

  @Input() title;
  @Input() payer;
  @Input() currency;
  constructor() { }

  ngOnInit(): void {
  }

}
